import { Component } from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface DatabaseListPageProps extends NSARouterMakerResult, CredentialProps { }

export default class DatabaseListPage extends Component<DatabaseListPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section lists all the database credentials saved in your workspace, for any engine such as MySQL, PostgreSQL, MongoDB, Redis, ClickHouse, or Elasticsearch, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
                }}
                pages={{
                    entity: CredentialEntities.database(this.props),
                    list: {}
                }}
            >
                <></>
            </CredentialLayout >
        );
    }
}